import { Component } from '@angular/core';

import { Platform, MenuController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthenticateService } from './services/authentication.service';
import { Router } from '@angular/router';
import {Storage} from '@ionic/storage';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  public appPages = [
    {
      title: 'Ranking Ufficiali',
      url: '/ranking',
      icon: 'list',
      src: 'assets/icon/lupo_icon.svg',
      show:true,
    },
    {
      title: 'Gare Autorganizzate',
      url: '/list',
      icon: 'list',
      src: 'assets/icon/piattello2.svg',
      show:true,
    },    
   
    {
      title: 'Lupi',
      url: '/home',
      icon: 'people',
      src: 'assets/logo.svg',
      show:false,
    },
    {
      title: 'Accedi',
      url: '/login',
      icon: 'lock',
      src: '',
      show:true
    },
    {
      title: 'Registrati',
      url: '/registrazione',
      icon: 'person-add',
      src: '',
      show:false
    },
    {
      title: 'Ranking Archiviati',
      url: '/rankingarchiviati',
      icon: 'list',
      src: 'assets/icon/lupo_icon.svg',
      show:false,
    }

  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public auth: AuthenticateService,
    private router: Router,
    public storage:Storage,
    public menu:MenuController
  ) {
    this.initializeApp();
  }
  logout() {
    // this.router.navigate(['/login']);
    this.auth.logoutUser().then((r)=>{
      this.storage.clear();
      this.open_silente();
    })
    
  }
  open_silente() {
    window.open('https://www.ilsilente.it', '_self');
  }
  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      
      this.auth.loggato$.subscribe((r)=>{
        if(r == true){
          this.appPages[5].show = false;
          this.appPages[4].show = false; 
          this.appPages[3].show = false;
          this.appPages[2].show = false;
          this.appPages[1].show = r;
          this.appPages[0].show = r;
        }
        else if(r == 99){
          this.appPages[5].show = true;
          this.appPages[4].show = false; 
          this.appPages[3].show = false;
          this.appPages[2].show = true;
          this.appPages[1].show = true;
          this.appPages[0].show = true;
        }
        else{
          this.appPages[5].show = false;
          this.appPages[4].show = false; 
          this.appPages[3].show = false;
          this.appPages[2].show = false;
          this.appPages[1].show = false;
          this.appPages[0].show = false;
        }
        
      })
        
      
    });
  }

  close_menu(){
    this.menu.toggle();
  }
}
